import { useCallback } from 'react';

import { useScanToPayMachine } from '../../machine';
import { type ScanToPayMachineServices } from '../../machine/scan-to-pay.machine.types';
import { useScanToPayCreditBalance } from '../useScanToPayCreditBalance';
import { useScanToPayDefaultPaymentMethod } from '../useScanToPayDefaultPaymentMethod';
import { useScanToPayIdentifyToken } from '../useScanToPayIdentifyToken';
import { useScanToPayLoyaltyProfile } from '../useScanToPayLoyaltyProfile';
import { useScanToPayPaymentMethods } from '../useScanToPayPaymentMethods';
import { useScanToPayPaymentToken } from '../useScanToPayPaymentToken';

export const useScanToPayState = () => {
  const { fetchLoyaltyProfile } = useScanToPayLoyaltyProfile();
  const { fetchCredits } = useScanToPayCreditBalance();
  const { fetchPaymentMethods } = useScanToPayPaymentMethods();
  const { fetchIdentifyToken } = useScanToPayIdentifyToken();
  const { fetchPaymentToken } = useScanToPayPaymentToken();
  const { setDefaultPaymentMethod } = useScanToPayDefaultPaymentMethod();

  const fetchData = useCallback(async (): Promise<
    ScanToPayMachineServices['fetchData']['data']
  > => {
    const [{ availablePoints, pointsRewards }, { availableCredit }, { paymentMethods }] =
      await Promise.all([fetchLoyaltyProfile(), fetchCredits(), fetchPaymentMethods()]);

    return {
      availablePoints,
      availableCredit,
      pointsRewards,
      paymentMethods,
    };
  }, [fetchLoyaltyProfile, fetchCredits, fetchPaymentMethods]);

  return useScanToPayMachine({
    fetchData,
    fetchIdentifyToken,
    fetchPaymentToken,
    fetchCredits,
    setDefaultPaymentMethod,
  });
};
